// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"855":"css/app.6924","8467":"css/admin-app.6924"}[chunkId] + ".css";
};